import { defineStore } from "pinia";

export const useDialogStore = defineStore("dialogs", {
  state: () => ({
    dialogState: {},
    parentDialogs: [],
    dialogHistory: [],
    properties: {},
  }),
  getters: {
    getDialogState: (state) => (dialog) => {
      return state.dialogState[dialog] || false;
    },
    getDialogProperties: (state) => (dialog) => {
      return state.properties[dialog] || {};
    },
    getParentDialogs: (state) => state.parentDialogs,
  },
  actions: {
    updateDialogState({ dialog, val, parentDialog }) {
      if (val) {
        if (parentDialog && !this.parentDialogs.includes(parentDialog)) {
          this.parentDialogs.push(parentDialog);
        }

        if (!parentDialog && !val) {
          this.parentDialogs.pop();
        }

        for (let key in this.dialogState) {
          if (
            key != dialog &&
            this.parentDialogs &&
            !this.parentDialogs.includes(key)
          )
            this.dialogState = { ...this.dialogState, [key]: false };
        }
      }

      this.dialogState = { ...this.dialogState, [dialog]: val };

      if (val) {
        this.dialogHistory.push(dialog);
      } else {
        this.dialogHistory = this.dialogHistory.filter(
          (hDialog) => hDialog !== dialog
        );
      }
    },
    setDialogProperties({ dialog, properties, refresh = false }) {
      if (!this.properties[dialog]) {
        this.properties = Object.assign({}, this.properties, { [dialog]: {} });
      }
      if (refresh) {
        this.properties[dialog] = Object.assign({}, properties);
      } else {
        this.properties[dialog] = Object.assign(
          {},
          this.properties[dialog],
          properties
        );
      }
    },
    deleteDialogProperties(dialog) {
      delete this.properties[dialog];
    },
  },
});
